import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter } from "@chakra-ui/react"
import { COLORS } from "@/common/constants";

const ModalLogOut = ({ isOpen, onClose, title, handleConfirmLogOut }: any) => {
    return (
        <Modal onClose={onClose} isOpen={isOpen} isCentered>
            <ModalOverlay />
            <ModalContent borderRadius={15} padding={5}>
                <ModalHeader textAlign='center'>{title}</ModalHeader>
                <ModalCloseButton onClick={onClose} _focus={{ outline: 'none', boxShadow: 'none' }} />
                <ModalBody textAlign='center' marginTop={-5}>
                    Are you sure you want to log out?
                </ModalBody>
                <ModalFooter style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: 10 }}>
                    <Button onClick={onClose} borderColor='#D0D5DD' bgColor='white' width='100px'>Cancel</Button>
                    <Button onClick={handleConfirmLogOut} bgColor={COLORS.BUTTON.BACKGROUND} color={COLORS.BUTTON.FOREGROUND} width='100px'>OK</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ModalLogOut;